import { isNil } from "ramda";
import { combinePath } from "../../dataConnections/dataConnection.utils";
import { ensureSharePointFilename } from "../sharePoint/sharePointHelper";
import { xmlToString } from "../../xmlUtility";

function sharePointSubmitAdapter(
    definition,
    template,
    shpAccess,
    dataSources,
) {
    let url = combinePath(template.getBasePath(), definition.folder);

    const getDynamicFileName = () =>
        dataSources
            .getMainDocumentElement()
            .evaluateString(definition.fileName);

    const getBaseFileName = () =>
        definition.fileNameType === "expression"
            ? getDynamicFileName()
            : definition.fileName;

    function getFileName() {
        var baseName = getBaseFileName();

        return /.xml$/i.test(baseName)
            ? baseName
            : baseName + ".xml";
    }

    function isOverwrite() {
        return definition.overwrite;
    }

    function getXmlString(xml) {
        const xmlNode = xml || dataSources.getDom().getNode();

        return xmlToString(xmlNode);
    }

    function getOverwrite(overwrite) {
        if (!isNil(overwrite)){
            return !!overwrite;
        }

        return isOverwrite();
    }

    function executeAsync({ xml, overwrite, folderUrl } = {}) {
        const actualFolderUrl = folderUrl || url;
        const fileName = ensureSharePointFilename(getFileName());
        const xmlStr = getXmlString(xml);
        const actualOverwrite = getOverwrite(overwrite);

        return shpAccess.submitToLibraryAsync(
            actualFolderUrl,
            fileName,
            xmlStr,
            actualOverwrite,
        );
    }

    function setUrl(spSiteUrl) {
        url = spSiteUrl;
    }

    function getUrl() {
        return url;
    }

    // interface
    return {
        executeAsync,
        setUrl,
        getUrl
    };
}

export default sharePointSubmitAdapter;